/* eslint-disable react/no-unused-class-component-methods */
import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

import isEqualWith from 'lodash/isEqualWith';

import ModificationTrackingForm from '../components/modificationTrackingForm';

const STRING_FIELD_TYPES = ['Color', 'Date', 'Text', 'TextArea'];

const ModificationTrackingFormContainer = createReactClass({
  propTypes: {
    formPrepend: PropTypes.node,
    onCancelClick: PropTypes.func,
    onSaveClick: PropTypes.func.isRequired,
    onFormUpdate: PropTypes.func,
    model: PropTypes.objectOf(PropTypes.any).isRequired,
    schema: PropTypes.objectOf(PropTypes.any).isRequired,
    onError: PropTypes.func,
    isDisabled: PropTypes.bool,
  },

  statics: {
    getDerivedStateFromProps({ model }, state) {
      return { ...(!isEqualWith(model, state.model) && { model, modifiedModel: model }) };
    },
  },

  getDefaultProps() {
    return {
      formPrepend: null,
      onCancelClick: () => {},
      onFormUpdate: () => {},
      onError: () => {},
      isDisabled: false,
    };
  },

  getInitialState() {
    const { model } = this.props;

    return {
      model,
      modifiedModel: model,
      isSaveButtonDisabled: true,
      isSubmittingForm: false,
    };
  },

  onFormLoad({ hasError }) {
    this.setState({ isSaveButtonDisabled: hasError });
  },

  onFormUpdate(onFormUpdateArgs) {
    const { update, hasError } = onFormUpdateArgs;
    const { modifiedModel: preUpdateModel } = this.state;
    const { onFormUpdate } = this.props;
    const modifiedModel = { ...preUpdateModel, ...update };

    this.setState({ modifiedModel, isSaveButtonDisabled: hasError });

    onFormUpdate(onFormUpdateArgs);
  },

  async onSaveClick() {
    const { onSaveClick, onError } = this.props;
    const { modifiedModel } = this.state;

    this.setState({ isSubmittingForm: true });

    try {
      await onSaveClick({ modifiedModel });
    } catch (error) {
      onError(error);
    }

    this.setState({ isSubmittingForm: false });
  },

  onCancelClick() {
    const { model, onCancelClick } = this.props;

    this.setState({ modifiedModel: model });
    onCancelClick({ model });
  },

  // treat null string fields in response data as ''
  // https://github.com/intellum/exceed/issues/50491
  isEqualOverride(a, b, key) {
    if (STRING_FIELD_TYPES.includes(this.props.schema[key]?.type) && !a && b === '') return true;
  },

  render() {
    const { model, modifiedModel, isSaveButtonDisabled, isSubmittingForm } = this.state;
    const { className, formPrepend, isDisabled, modifiedClassName, schema } = this.props;
    const isModelModified = !isEqualWith(model, modifiedModel, this.isEqualOverride);

    return (
      <ModificationTrackingForm
        className={className}
        formPrepend={formPrepend}
        isModelModified={isModelModified}
        isSaveButtonDisabled={isSaveButtonDisabled}
        isSubmittingForm={isSubmittingForm}
        isDisabled={isDisabled}
        schema={schema}
        model={modifiedModel}
        modifiedClassName={modifiedClassName}
        onFormUpdate={this.onFormUpdate}
        onFormLoad={this.onFormLoad}
        onSaveClick={this.onSaveClick}
        onCancelClick={this.onCancelClick}
      />
    );
  },
});

export default ModificationTrackingFormContainer;
